import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    createLabReagentSuccess, createLabReagentFailure,
    getAllLabReagentSuccess, getAllLabReagentFailure,
    getByIdLabReagentSuccess, getByIdLabReagentFailure,
    updateLabReagentSuccess, updateLabReagentFailure,
    getReagentAlertsSuccess, getReagentAlertsFailure,
    adjustReagentQuantitySuccess, adjustReagentQuantityFailure,
    getUsageHistorySuccess, getUsageHistoryFailure,
    getDepletionSummarySuccess, getDepletionSummaryFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

function* createRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json", "X-Current-Branch": currentBranch.id },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/reagents`, requestDetail);
        yield put(createLabReagentSuccess(response));
    } catch (error) { yield put(createLabReagentFailure(error?.response?.message || error)); }
}

function* getAllRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        let url = `${process.env.REACT_APP_SERVER_API}api/laboratory/reagents`;
        const params = action.payload || {};
        const queryParts = [];
        if (params.departmentId) queryParts.push(`departmentId=${params.departmentId}`);
        if (params.analyzerId) queryParts.push(`analyzerId=${params.analyzerId}`);
        if (queryParts.length) url += `?${queryParts.join('&')}`;
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, url, requestDetail);
        yield put(getAllLabReagentSuccess(response));
    } catch (error) { yield put(getAllLabReagentFailure(error?.response?.message || error)); }
}

function* getByIdRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/reagents/${action.payload}`, requestDetail);
        yield put(getByIdLabReagentSuccess(response));
    } catch (error) { yield put(getByIdLabReagentFailure(error?.response?.message || error)); }
}

function* updateRequest(action) {
    try {
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/reagents`, requestDetail);
        yield put(updateLabReagentSuccess(response));
    } catch (error) { yield put(updateLabReagentFailure(error?.response?.message || error)); }
}

function* alertsRequest() {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/reagents/alerts`, requestDetail);
        yield put(getReagentAlertsSuccess(response));
    } catch (error) { yield put(getReagentAlertsFailure(error?.response?.message || error)); }
}

function* adjustQuantityRequest(action) {
    try {
        const { id, ...body } = action.payload;
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(body)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/reagents/${id}/adjust`, requestDetail);
        yield put(adjustReagentQuantitySuccess(response));
    } catch (error) { yield put(adjustReagentQuantityFailure(error?.response?.message || error)); }
}

function* usageHistoryRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const { id, page, limit } = action.payload;
        let url = `${process.env.REACT_APP_SERVER_API}api/laboratory/reagents/${id}/usage-history`;
        const queryParts = [];
        if (page) queryParts.push(`page=${page}`);
        if (limit) queryParts.push(`limit=${limit}`);
        if (queryParts.length) url += `?${queryParts.join('&')}`;
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json" }
        };
        const response = yield call(requestHandler, url, requestDetail);
        yield put(getUsageHistorySuccess(response));
    } catch (error) { yield put(getUsageHistoryFailure(error?.response?.message || error)); }
}

function* depletionSummaryRequest() {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/reagents/depletion/summary`, requestDetail);
        yield put(getDepletionSummarySuccess(response));
    } catch (error) { yield put(getDepletionSummaryFailure(error?.response?.message || error)); }
}

function* saga() {
    yield takeLatest('labReagent/createLabReagentRequest', createRequest);
    yield takeLatest('labReagent/getAllLabReagentRequest', getAllRequest);
    yield takeLatest('labReagent/getByIdLabReagentRequest', getByIdRequest);
    yield takeLatest('labReagent/updateLabReagentRequest', updateRequest);
    yield takeLatest('labReagent/getReagentAlertsRequest', alertsRequest);
    yield takeLatest('labReagent/adjustReagentQuantityRequest', adjustQuantityRequest);
    yield takeLatest('labReagent/getUsageHistoryRequest', usageHistoryRequest);
    yield takeLatest('labReagent/getDepletionSummaryRequest', depletionSummaryRequest);
}

export default saga;
